export const ChangePasswordFormInitialValues = {
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};
